import React, { useEffect } from 'react';
import { useState } from 'react';
import MyInput from '../../components/ui/MyInput';
import './extra.css';
import MyTextarea from '../../components/ui/MyTextarea';
import PrimaryButton from '../../components/ui/PrimaryButton';
import MyUploadMediaInput from '../../components/ui/MyUploadMediaInput';
import SelectRadio from '../../components/ui/SelectRadio';
import MarketingPhone from '../../components/ui/MarketingPhone';
import { RadioGroup, Radio } from '@nextui-org/react';
import MyDatePicker from '../../components/ui/MyDatePicker';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import LayeredDashboard from '../LayeredDashboard';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import { Calendar } from 'primereact/calendar';
import { useDispatch } from 'react-redux';
import CreateAction from '../../components/operational/createAction';
import systemSlice from '../../redux/systemSlice';
import allTabs from '../DashboardTabs';
import { useSelector } from 'react-redux';
import LanguageSelector from '../../components/ui/System/LanguageSelector';
import UseTemplate from './UseTemplate';
import LayeredDashboardModal from './Modals/LayeredDashboardModal';
import Datepicker from 'react-tailwindcss-datepicker';
import dayjs from 'dayjs';
import { TimePicker } from "antd";


const AddPhoneNoti = ({ tab, getNotifications, setIsActive, activeNotification, setActiveNotification }) => {
  const categoryObject = useSelector(state => state.themeSlice.categories);
  const category = categoryObject ? Object.values(categoryObject) : [];
  const brandObject = useSelector(state => state.themeSlice.brands);
  const brand = brandObject ? Object.values(categoryObject) : [];
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [notificationHeader, setNotificationHeader] = useState('');
  const [notificationDescription, setNotificationDescription] = useState('');
  const [datetime24h, setDateTime24h] = useState(null);
  const [hours, setHours] = useState(null);
  const [minutes, setMinutes] = useState(null);

  const [timer, setTimer] = useState('sendNow');
  const [selectedLink, setSelectedLink] = useState('');
  const [isActiveTemplateModal, setIsActiveTemplateModal] = useState(false);
  useEffect(() => {
    if (activeNotification) {
      setNotificationHeader(activeNotification?.notificationTitle);
      setNotificationDescription(activeNotification?.notificationBody);
      const willSendTimeDate = new Date(activeNotification?.willSendTime)
      initiliazeDate(willSendTimeDate)
      setTimer('sendLater');
      setSelectedLink(activeNotification?.data?.raw);
    }
  }, [activeNotification]);
  const radioItems = [
    { value: 'link', label: 'Link', isDisabled: false },
    { value: 'product', label: 'Ürün', isDisabled: true },
    { value: 'category', label: 'Kategori', isDisabled: true },
    { value: 'brand', label: 'Marka', isDisabled: true },
    { value: 'page', label: 'Sayfa', isDisabled: true },
  ];
  const [selectedType, setSelectedType] = useState(radioItems[0].value);

  const saveNotification = async status => {
    if (!selectedLanguage?.code) return;
    const notification = {
      notification: {
        notificationTitle: notificationHeader,
        notificationBody: notificationDescription,
        data: {
          pointTo: selectedLink,
          pointToType: 'link',
        },
        language: selectedLanguage?.code,
      },
      willSendTime: timer === 'sendNow' ? new Date().getTime() : datetime24h?.setHours(hours, minutes),
      status,
    };

    const response = await CreateAction({
      method: 'post',
      path: '/sendnotification',
      showPreLoader: true,
      isFileUploading: false,
      data: notification,
    });

    if (response.error) return;
    getNotifications();
    setIsActive(false);
  };

  const updateNotification = async status => {
    if (!selectedLanguage?.code) return;
    const notification = {
      notification: {
        title: notificationHeader,
        body: notificationDescription,
        data: {
          pointTo: selectedLink,
          pointToType: 'link',
        },
        language: selectedLanguage?.code,
      },
      willSendTime: timer === 'sendNow' ? new Date().getTime() : datetime24h?.setHours(hours, minutes),
      id: activeNotification?.id,
      status,
    };

    const response = await CreateAction({
      method: 'patch',
      path: `/sendnotification/${activeNotification?.id}`,
      showPreLoader: true,
      isFileUploading: false,
      data: notification,
    });

    if (response.error) return;
    getNotifications();
    setIsActive(false);
    setActiveNotification(null);
  };

  const initiliazeDate = (currentDate) => {
    const hour = currentDate.getHours()
    const minute = currentDate.getMinutes()
    setHours(hour)
    setMinutes(minute)
    currentDate.setHours(0, 0, 0, 0)
    setDateTime24h(currentDate);

  }

  console.log(hours, minutes)
  return (
    <>
      <LayeredDashboardHeader
        tab={tab}
        setIsActive={setIsActive}
        onLeave={() => {
          setActiveNotification(false);
          setIsActive(false);
        }}
      >
        <button
          className={`text-[15px] py-[11px] px-4 flex items-center border-1 border-[#E3E8EF] justify-center bg-white  rounded text-[#8A92A6] cursor-pointer `}
          onClick={() => {
            setIsActive(false);
          }}
        >
          Vazgeç
        </button>
        <PrimaryButton
          classes="text-[16px] !py-3 bg-[#F2994a]  hover:bg-[#F2994a] "
          value="Taslak Olarak Kaydet"
          onClick={() => {
            activeNotification?.id ? updateNotification('DRAFT') : saveNotification('DRAFT');
            setActiveNotification(null);
          }}
        />
        <PrimaryButton
          classes="text-[16px] !py-3 "
          onClick={() => {
            activeNotification?.id ? updateNotification('UNSENT') : saveNotification('UNSENT');
          }}
          value={'Yayınla'}
        />
      </LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex justify-center items-center flex-col gap-[20px]">
            <div className="bg-white p-[20px] max-w-[1120px]  w-[100%] rounded-[10px]">
              <div className="flex lg:flex-row w-full">
                <div className="border-r mt-[30px] lg:mt-[0px] border-[#F8F8F8] flex flex-row w-full justify-between align-center">
                  <span className="text-[#5E5873] font-medium text-[18px] mb-[20px] block">Dil Ayarları</span>
                  <div className="w-[300px]">
                    <LanguageSelector
                      type="dropdown"
                      selectedLanguage={selectedLanguage}
                      activeNotification={activeNotification}
                      setSelectedLanguage={setSelectedLanguage}
                    ></LanguageSelector>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-[20px] max-w-[1120px]  w-[100%] rounded-[10px]">
              <div className="flex flex-col-reverse lg:flex-row">
                <div className="border-r mt-[30px] lg:mt-[0px] border-[#F8F8F8] w-[100%] lg:w-[50%]">
                  <div className="lg:pr-[20px]">
                    <div className="addCategoryInputs">
                      <span className="text-[#5E5873] font-medium text-[18px] mb-[20px] block">Bildirim Ayarları</span>
                      <div className=" flex flex-col mb-[30px]">
                        <span className="text-[#5E5873] mb-[5px] block font-medium text-[14px] ">
                          Bildirim Başlığı <span className="text-[#7059EF]">*</span>
                        </span>
                        <MyTextarea
                          placeholder=""
                          value={notificationHeader}
                          onChange={value => setNotificationHeader(value)}
                          isLengthActive={true}
                        />
                      </div>
                      <div className=" flex flex-col mb-[30px]">
                        <span className="text-[#5E5873] mb-[5px] block font-medium text-[14px] ">
                          Bildirim Alt Metni <span className="text-[#7059EF]">*</span>
                        </span>
                        <MyTextarea
                          placeholder=""
                          value={notificationDescription}
                          onChange={value => setNotificationDescription(value)}
                          isLengthActive={true}
                        />
                      </div>
                    </div>
                    <div className=" flex flex-col mb-[30px] gap-[10px]">
                      <span className="text-[#5E5873 block font-semibold text-[18px] ">
                        Yönlendirme <span className="text-[#7059EF]">*</span>
                      </span>

                      <RadioGroup
                        defaultValue={'link'}
                        value={selectedType}
                        onChange={e => {
                          setSelectedType(e.target.value);
                        }}
                      >
                        {radioItems?.map(item => {
                          return (
                            <Radio isDisabled={item.isDisabled} value={item.value}>
                              {item.label}
                            </Radio>
                          );
                        })}
                      </RadioGroup>
                      <MyInput
                        placeholder="Link giriniz."
                        value={selectedLink}
                        onChange={value => setSelectedLink(value)}
                        isLengthActive={true}
                      />
                    </div>

                    <div className=" flex flex-col mb-[30px]">
                      <span className="text-[#5E5873] mb-[20px] block font-semibold text-[18px] ">Zamanlama</span>
                      <RadioGroup
                        defaultValue={'sendNow'}
                        value={timer}
                        onChange={e => {
                          setTimer(e.target.value);
                          if (e.target.value === "sendLater") {
                            const today = new Date()
                            initiliazeDate(today)

                          }
                        }}
                      >
                        <Radio value="sendNow">Şimdi Gönder</Radio>
                        <Radio value="sendLater">İleri Tarihe Ayarla</Radio>
                      </RadioGroup>
                      {timer === 'sendLater' && (
                        <div className="mt-[20px]">
                          <div className=" w-[100%] pr-[10px] flex flex-row gap-[5px]">
                            <div className="flex px-[12px] rounded-[5px] border-1 border-[#E3E8EF] items-center gap-[15px]">

                              <Datepicker
                                displayFormat='YYYY-MM-DD'
                                useRange={false}
                                asSingle={true}
                                disabledDates={[{ startDate: new Date(0), endDate: dayjs().subtract(1, "day").toDate() }]}
                                startWeekOn="mon"
                                value={{ startDate: datetime24h, endDate: datetime24h }}
                                primaryColor={"purple"}
                                onChange={newValue => setDateTime24h(newValue.startDate)}
                              />
                            </div>
                            <div className='flex flex-row gap-[5px]'>
                              <TimePicker
                                showNow={false}
                                value={dayjs(`${hours}:${minutes}:0`, 'HH:mm:ss')}
                                onCalendarChange={(e) => {
                                  setMinutes(e.minute())
                                  setHours(e.hour())
                                }}
                                needConfirm={false}
                                showSecond={false} size="large" />



                            </div>
                          </div>
                          <div></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className=" w-[100%] lg:w-[50%]">
                  <div className="lg:pl-[20px]">
                    <div className="flex justify-between">
                      <span className="text-[#5E5873] font-medium text-[18px] mb-[20px] block">Önizleme</span>

                      <PrimaryButton onClick={() => setIsActiveTemplateModal(true)} value={'Şablon Kullan'} />
                    </div>
                    <div style={{ wordWrap: 'break-word' }}>
                      <MarketingPhone
                        notificationHeader={notificationHeader}
                        notificationDescription={notificationDescription}
                        phoneType={1}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LayeredDashboardModal isActive={isActiveTemplateModal}>
        <UseTemplate
          setIsActive={setIsActiveTemplateModal}
          setNotificationHeader={setNotificationHeader}
          setNotificationDescription={setNotificationDescription}
          tab={{
            ...tab,
            activeTabs: [...tab?.activeTabs, 'Şablon Kullan'],
            activeTabTitles: [...tab?.activeTabTitles, 'Şablon Kullan'],
          }}
        ></UseTemplate>
      </LayeredDashboardModal>
    </>
  );
};

export default AddPhoneNoti;
